import React from 'react';

export default function OurMission() {
  return (
    <main className="page">
      <section className="hero">
        <p className="hero__eyebrow">What drives us</p>
        <h1 className="hero__title">Our Mission</h1>
        <p className="hero__subtitle">
          Our mission is to create a trusted online space that showcases the work of
          independent journalists and media outlets that will become an important part of an
          informed citizen&apos;s daily news consumption.
        </p>
      </section>

      <div className="legal">
        <p>
          OnlyFreeNews is founded on high journalism standards and seeks to uphold the
          following principles:
        </p>
        <ul>
          <li>Independent</li>
          <li>Free-Thinking</li>
          <li>Fair</li>
          <li>Accurate</li>
          <li>Factual</li>
          <li>Transparent</li>
        </ul>

        <h2 className="section-heading">Our Commitment</h2>
        <p>
          The success of OnlyFreeNews starts and ends with our commitment to the reader to
          do the following:
        </p>
        <ul>
          <li>Only share articles which adhere to the highest journalistic standards.</li>
          <li>
            Implement a process where every journalist and media organization featured on
            the site is vetted against our journalistic standards and principles.
          </li>
          <li>
            Avoid publishing articles from journalists that are controlled or influenced by
            corporations, main-stream media outlets, government entities, special interest
            groups or non-government organizations (NGOs).
          </li>
          <li>Promote truthful and fact-based reporting because facts matter and truth does exist.</li>
          <li>
            Emphasize and enforce transparency that empowers the reader to make decisions on
            the accuracy and truthfulness of an article for themselves.
          </li>
        </ul>

        <p>Join us and the growing independent journalism movement by becoming a reader today!</p>
      </div>
    </main>
  );
}
